import { OnInit, Component, AfterViewInit } from '@angular/core';
import { StatisticService } from 'src/app/services/statistic.service';
import { AnalyticDataSource } from 'src/app/services/analytic.datasource';

@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.css'],
})
export class ApprovalsComponent implements OnInit, AfterViewInit {
  public noDataAvailable: boolean = false;
  public dataSource: AnalyticDataSource = new AnalyticDataSource(
    this.statisticService
  );

  public displayedColumns = [
    'NudgeIdentifier',
    'CheckBox',
    'ClientId',
    'ClientName',
    'ParentGrouping',
    'DueDateStr',
    'CountryOfIncorporation',
    'Revenue',
    'Bucket',
    'ClientType',
    'Analyst',
    'QCReviewer',
    'ClientContactTitle',
    'ClientContactEmail',
    'ClientContactName',
    'CompletionDateStr',
    'InitialOutreachDateStr',
    'ReasonForDescope',
    'Products',
    'RiskScore',
    // 'Status',
    // 'Stage',
    'Aging',
    'Link',
    'NextStage',
    'RowMenu',
  ];

  constructor(public statisticService: StatisticService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  handleNoTableData(event: boolean) {
    this.noDataAvailable = event;
  }

  onAddNewEntry() {}

  onPrint() {}

  onUploadExcel() {}

  changeDisplayedColumns(chips: any) {
    this.displayedColumns = chips;
  }
}
